const OrganizationType = {
  SAAS: 'saas',
  ECOMMERCE: 'eCommerce',
  LOAN_BROKER: 'loanBroker',
  OTHER: 'other',
  NONE: 'none',
};

export default OrganizationType;
